import { OfficeBuildingIcon } from '@heroicons/react/outline'

const DEFAULT_CAMPAIGNS = [
    {
        title: 'Seasonal pushes',
        description:
            'Time mail to mosquito, ant, termite swarm, and rodent season so offers land right when homeowners notice the problem.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'bolt',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Recurring plans',
        description:
            'Promote quarterly and annual protection plans instead of chasing one-time treatments.',
        iconBg: 'bg-[#FAB331]/20',
        iconColor: 'text-secondary',
        icon: 'home',
    },
    {
        title: 'Route density',
        description:
            'Mail the streets around stops you already service so techs add accounts without adding drive time.',
        iconBg: 'bg-[#DBEAFE]',
        iconColor: 'text-[#1E40AF]',
        icon: 'map-pin',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Win back customers',
        description:
            'Bring cancelled and lapsed accounts back with reactivation offers, referrals, and follow-up.',
        iconBg: 'bg-[#DCFCE7]',
        iconColor: 'text-[#166534]',
        icon: 'refresh',
    },
    {
        title: 'Inspection offers',
        description: 'Promote free inspections or first-treatment offers.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'clipboard',
    },
    {
        title: 'New mover targeting',
        description:
            'Reach new homeowners in your service area before they pick another provider.',
        iconBg: 'bg-gray-200',
        iconColor: 'text-gray-600',
        icon: 'target',
    },
]

function CampaignIcon({ name, className }) {
    const icons = {
        'building-office': <OfficeBuildingIcon className={className} />,
        wrench: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94L14.7 6.3z" />
            </svg>
        ),
        bolt: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
        ),
        home: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
        ),
        'map-pin': (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </svg>
        ),
        refresh: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10" />
                <polyline points="1 20 1 14 7 14" />
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
            </svg>
        ),
        clipboard: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="1" />
                <line x1="9" y1="12" x2="15" y2="12" />
                <line x1="9" y1="16" x2="13" y2="16" />
            </svg>
        ),
        target: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
            </svg>
        ),
        star: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polygon points="12 2 15 8.5 22 9.3 16.8 14 18.2 21 12 17.4 5.8 21 7.2 14 2 9.3 9 8.5 12 2" />
            </svg>
        ),
        gift: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polyline points="20 12 20 22 4 22 4 12" />
                <rect x="2" y="7" width="20" height="5" />
                <line x1="12" y1="22" x2="12" y2="7" />
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
            </svg>
        ),
        key: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <circle cx="7.5" cy="15.5" r="5.5" />
                <path d="M12 11l9-9" />
                <path d="M17 6l2 2" />
                <path d="M14 9l2 2" />
            </svg>
        ),
        percent: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <line x1="19" y1="5" x2="5" y2="19" />
                <circle cx="6.5" cy="6.5" r="2.5" />
                <circle cx="17.5" cy="17.5" r="2.5" />
            </svg>
        ),
        users: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
        ),
        handshake: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M11 17l2 2a2.8 2.8 0 0 0 4 0l4-4" />
                <path d="M14 14l2.5 2.5a2.8 2.8 0 0 0 4 0" />
                <path d="M3 8l5-5 4 4" />
                <path d="M21 8l-5-5-6.5 6.5a2.1 2.1 0 0 0 3 3L14 11" />
                <path d="M3 8v7l4 4a2.8 2.8 0 0 0 4 0" />
            </svg>
        ),
    }
    return icons[name] || null
}

function SparklesIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="none"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
            />
        </svg>
    )
}

export default function CampaignStrategy({
    eyebrow = 'Pest control campaign strategy',
    title = 'Direct mail built around the pest accounts you actually want more of.',
    description = 'Reach the homeowners most likely to sign up for recurring service, termite protection, mosquito programs, or one-time treatments, with mail that is targeted, seasonal, and built around the work you want more of.',
    campaigns = DEFAULT_CAMPAIGNS,
}) {
    return (
        <section className="bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
                <div className="flex flex-col gap-4 max-w-3xl mb-10">
                    <span className="text-secondary text-xs uppercase tracking-widest font-semibold">
                        {eyebrow}
                    </span>
                    <h2
                        className="text-[#3f454f] tracking-tight text-3xl md:text-[44px] font-bold"
                        style={{ lineHeight: 1.05 }}>
                        {title}
                    </h2>
                    <p
                        className="text-[color-mix(in_oklab,_#3F454F_70%,_transparent)] text-lg"
                        style={{ lineHeight: '28px' }}>
                        {description}
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-5">
                    {campaigns.map((campaign, i) => (
                        <div
                            key={i}
                            className="group relative flex flex-col gap-4 p-6 lg:p-7 bg-[#FFF7EC] rounded-2xl border border-gray-200/50 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl">
                            <div
                                className={
                                    campaign.badge
                                        ? 'flex flex-row items-start justify-between gap-3'
                                        : ''
                                }>
                                <div
                                    className={`w-12 h-12 rounded-xl ${campaign.iconBg} flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-110 group-hover:rotate-3`}>
                                    <CampaignIcon
                                        name={campaign.icon}
                                        className={`w-6 h-6 ${campaign.iconColor}`}
                                    />
                                </div>
                                {campaign.badge && (
                                    <div className="flex flex-row items-center gap-1 px-2 py-px rounded-full bg-transparent border border-secondary/30 -mt-2 -mr-2">
                                        <SparklesIcon className="w-3 h-3 text-secondary" />
                                        <span className="text-[0.625rem] leading-7 font-bold tracking-wider text-secondary uppercase">
                                            {campaign.badge}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <h3
                                className="text-[#3F454F] font-bold text-lg md:text-[22px]"
                                style={{ lineHeight: '28px' }}>
                                {campaign.title}
                            </h3>
                            <p
                                className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]"
                                style={{ lineHeight: 1.625 }}>
                                {campaign.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
